import React, { useEffect, useRef, useState } from "react";

import { apiFetch } from "./api";

function Profile() {

  const whatsappSignupData = useRef({
    code: null,
    waba_id: null,
    phone_number_id: null
  });

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== "https://www.facebook.com") {
        return;
      }

      let data;

      try {
        data =
          typeof event.data === "string"
            ? JSON.parse(event.data)
            : event.data;
      } catch (error) {
        console.log(
          "Received non-JSON message from Meta:",
          event.data
        );
        return;
      }

      console.log("Meta Embedded Signup message:", data);

      if (data.type === "WA_EMBEDDED_SIGNUP") {
        console.log(
          "WhatsApp Embedded Signup event:",
          data.event
        );

        console.log(
          "WhatsApp Embedded Signup data:",
          data.data
        );

        // Save the WhatsApp details received from Meta
        if (data.data) {
          if (data.data.waba_id) {
            whatsappSignupData.current.waba_id =
              data.data.waba_id;
          }

          if (data.data.phone_number_id) {
            whatsappSignupData.current.phone_number_id =
              data.data.phone_number_id;
          }
        }

        console.log(
          "Stored WhatsApp signup data:",
          whatsappSignupData.current
        );

        // Try completing the exchange in case
        // the authorization code arrived first.
        completeWhatsAppExchange();
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const completeWhatsAppExchange = () => {
    const {
      code,
      waba_id,
      phone_number_id
    } = whatsappSignupData.current;

    console.log(
      "Checking WhatsApp exchange data:",
      {
        hasCode: !!code,
        waba_id,
        phone_number_id
      }
    );

    // We need all three before calling the backend.
    if (!code || !waba_id || !phone_number_id) {
      console.log(
        "WhatsApp exchange waiting for remaining Meta data..."
      );

      return;
    }

    console.log(
      "All WhatsApp authorization data received. Sending to Mukbi backend..."
    );

    apiFetch("/whatsapp/exchange", {
      method: "POST",
      body: JSON.stringify({
        code,
        waba_id,
        phone_number_id
      })
    })
      .then(async (res) => {
        const data = await res.json();

        if (!res.ok) {
          throw new Error(
            data.error ||
              "WhatsApp authorization failed"
          );
        }

        console.log(
          "WhatsApp authorization exchange successful:",
          data
        );

        alert("WhatsApp connected successfully.");

        // Clear temporary signup data
        whatsappSignupData.current = {
          code: null,
          waba_id: null,
          phone_number_id: null
        };
      })
      .catch((error) => {
        console.error(
          "WhatsApp authorization exchange failed:",
          error
        );

        alert(
          "WhatsApp connection could not be completed. Please try again."
        );
      });
  };

  const launchWhatsAppSignup = () => {
    if (!window.FB) {
      alert(
        "WhatsApp connection is not ready. Please try again."
      );
      return;
    }

    // Reset previous signup information
    whatsappSignupData.current = {
      code: null,
      waba_id: null,
      phone_number_id: null
    };

    console.log(
      "Launching WhatsApp Embedded Signup..."
    );

    window.FB.login(
      function (response) {
        console.log(
          "Facebook Login response:",
          response
        );

        if (response.authResponse) {
          const code =
            response.authResponse.code;

          console.log(
            "WhatsApp authorization code received."
          );

          // Save the code.
          // The Meta postMessage containing WABA
          // and phone number information may arrive
          // before OR after this callback.
          whatsappSignupData.current.code = code;

          console.log(
            "Stored authorization code. Waiting for Meta signup data..."
          );

          completeWhatsAppExchange();
        } else {
          console.log(
            "WhatsApp Embedded Signup was cancelled."
          );
        }
      },
      {
        config_id: "1736211197488590",
        response_type: "code",
        override_default_response_type: true,
        extras: {
          setup: {},
          featureType:
            "whatsapp_business_app_onboarding"
        }
      }
    );
  };

  const [user, setUser] = useState({
    name: "",
    email: "",
    organization: "",
    businessType: ""
  });

  const userId = localStorage.getItem("userId");

  useEffect(() => {
    apiFetch(`/user/${userId}`)
      .then(res => res.json())
      .then(data => setUser(data))
      .catch(err =>
        console.error("Error fetching user:", err)
      );
  }, [userId]);

  const disconnectWhatsApp = async () => {
    const confirmed = window.confirm(
      "Are you sure you want to disconnect WhatsApp Business from Mukbi?"
    );

    if (!confirmed) {
      return;
    }

    try {
      const res = await apiFetch("/whatsapp/disconnect", {
        method: "DELETE"
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(
          data.error || "Failed to disconnect WhatsApp"
        );
      }

      alert("WhatsApp disconnected successfully.");

      // Update the profile state immediately
      setUser({
        ...user,
        whatsappConnected: false,
        whatsappPhoneNumberId: undefined,
        whatsappBusinessAccountId: undefined,
        whatsappConnectedAt: undefined
      });

    } catch (error) {
      console.error(
        "WhatsApp disconnect error:",
        error
      );

      alert(
        "WhatsApp could not be disconnected. Please try again."
      );
    }
  };

  const handleSave = () => {
    apiFetch(`/user/${userId}`, {
      method: "PUT",
      body: JSON.stringify(user)
    })
      .then(res => res.json())
      .then(() => alert("Profile updated"))
      .catch(err => {
        console.error("Error updating profile:", err);
        alert("Something went wrong");
      });
  };

  const input = {

    width: "100%",

    padding: 10,

    marginBottom: 12,

    borderRadius: 6,

    border: "1px solid #ccc"

  };

  const button = {

    width: "100%",

    padding: 10,

    background: "#2c3e50",

    color: "white",

    border: "none",

    borderRadius: 6,

    cursor: "pointer",

    marginTop: 10

  };

  const [newPassword, setNewPassword] = useState("");


  const updatePassword = () => {
    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;

    if (!strongPasswordRegex.test(newPassword)) {
      alert(
        "Password must be 8+ chars, include uppercase, lowercase, number & special character"
      );
      return;
    }

    apiFetch("/change-password", {
      method: "PUT",
      body: JSON.stringify({
        newPassword
      })
    })
      .then(async (res) => {
        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.message || "Unable to update password.");
        }

        return data;
      })
      .then((data) => {
        alert("Password updated successfully. Please log in again with your new password.");

        setNewPassword("");

        // Clear the previous authentication session
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("userEmail");
        localStorage.removeItem("userName");
        localStorage.removeItem("whatsappConnected");

        // Return to login screen
        window.location.href = "/";
      })
      .catch((err) => {
        console.error("Error updating password:", err);
        alert(err.message || "Something went wrong. Please try again.");
      });
  };


  return (

    <div style={{ background: "#f5f6fa", minHeight: "100vh", padding: 20 }}>

      <div style={{

        maxWidth: 500,

        margin: "0 auto",

        background: "white",

        padding: 25,

        borderRadius: 10,

        boxShadow: "0 4px 12px rgba(0,0,0,0.08)"

      }}>

        {/* WHATSAPP - PRIMARY PROFILE SECTION */}

        <div

          style={{

            marginBottom: 25,

            padding: 20,

            border: "1px solid #e5e7eb",

            borderRadius: 10,

            background: "#fafafa"

          }}

        >

          <h3 style={{ marginTop: 0, marginBottom: 8 }}>

            💬 WhatsApp Business

          </h3>

          <p

            style={{

              marginTop: 0,

              marginBottom: 15,

              color: "#666",

              fontSize: 14,

              lineHeight: "1.5"

            }}

          >

            Connect your WhatsApp Business account to Mukbiz to manage

            customer conversations and leads from one place.

          </p>

          {user.whatsappConnected ? (
            <div
              style={{
                marginTop: "22px",
                padding: "18px 20px",
                border: "1px solid #d9e2dc",
                borderRadius: "10px",
                background: "#f8fbf9",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "20px"
              }}
            >
              {/* Status */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "9px",
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#27ae60"
                }}
              >
                <span
                  style={{
                    width: "10px",
                    height: "10px",
                    background: "#27ae60",
                    borderRadius: "50%",
                    display: "inline-block"
                  }}
                />
                Connected
              </div>

              {/* Disconnect */}
              <button
                onClick={disconnectWhatsApp}
                style={{
                  ...button,
                  width: "auto",
                  padding: "10px 20px",
                  background: "#c0392b",
                  fontSize: "14px",
                  borderRadius: "7px"
                }}
                onMouseOver={(e) =>
                  (e.target.style.background = "#a93226")
                }
                onMouseOut={(e) =>
                  (e.target.style.background = "#c0392b")
                }
              >
                🔌 Disconnect WhatsApp
              </button>
            </div>
          ) : (
            <button
              style={button}
              onClick={launchWhatsAppSignup}
              onMouseOver={(e) =>
                (e.target.style.background = "#34495e")
              }
              onMouseOut={(e) =>
                (e.target.style.background = "#2c3e50")
              }
            >
              💬 Connect WhatsApp Business
            </button>
          )}
        </div>

        {/* BUSINESS PROFILE */}

        <h2 style={{ marginBottom: 5 }}>

          🏢 Business Profile

        </h2>

        <div

          style={{

            color: "#666",

            marginBottom: 20,

            fontSize: 14

          }}

        >

          Manage your business account and Mukbi settings

        </div>

        {/* INPUTS */}

        <input

          style={input}

          value={user.name}

          onChange={(e) => setUser({ ...user, name: e.target.value })}

          placeholder="Name"

        />

        <input

          style={input}

          value={user.email}

          disabled

          placeholder="Email"

        />

        <input

          style={input}

          value={user.organization}

          onChange={(e) => setUser({ ...user, organization: e.target.value })}

          placeholder="Organization"

        />

        <input

          style={input}

          value={user.businessType}

          onChange={(e) => setUser({ ...user, businessType: e.target.value })}

          placeholder="Business Type"

        />

        <button

          style={button}

          onClick={handleSave}

          onMouseOver={(e) => e.target.style.background = "#34495e"}

          onMouseOut={(e) => e.target.style.background = "#2c3e50"}

        >

          💾 Save Business Profile

        </button>

        {/* SUBSCRIPTION */}

        <div

          style={{

            marginTop: 25,

            padding: 20,

            border: "1px solid #eee",

            borderRadius: 10,

            background: "#fafafa"

          }}

        >

          <h3 style={{ marginTop: 0 }}>📋 Subscription</h3>

          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>

            <b>Plan</b>

            <span>Mukbi Business Starter</span>

          </div>

          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>

            <b>Status</b>

            <span style={{ color: "green", fontWeight: "600" }}>

              🟢 Active

            </span>

          </div>

          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>

            <b>License</b>

            <span>Trial</span>

          </div>

          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>

            <b>Expiry</b>

            <span>30 Days Remaining</span>

          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>

            <b>Version</b>

            <span>V1.0 RC1</span>

          </div>

        </div>

        <div

          style={{

            marginTop: 15,

            padding: 10,

            background: "#ecfdf5",

            border: "1px solid #bbf7d0",

            borderRadius: 8,

            fontSize: 13,

            color: "#166534"

          }}

        >

          ✅ Your business account is active and ready to use.

        </div>




        {/* DIVIDER */}
        <hr style={{ margin: "25px 0" }} />

        {/* EMAIL VERIFICATION STATUS */}
        <div
          style={{
            marginTop: 10,
            padding: 12,
            background:
              user.emailVerified === true
                ? "#ecfdf5"
                : "#fef2f2",
            border:
              user.emailVerified === true
                ? "1px solid #bbf7d0"
                : "1px solid #fecaca",
            borderRadius: 8,
            fontSize: 13,
            color:
              user.emailVerified === true
                ? "#166534"
                : "#991b1b"
          }}
        >
          <strong>Email Verification: </strong>
          {user.emailVerified === true
            ? "✅ Verified"
            : "❌ Not Verified"}
        </div>

        {/* SECURITY */}
        <h3>🔐 Security</h3>

        {user.provider === "google" ? (
          <div
            style={{
              padding: 15,
              background: "#f3f4f6",
              borderRadius: 8,
              color: "#555",
              fontSize: 14,
              lineHeight: 1.5
            }}
          >
            🔐 Your account uses Google Sign-In.
            Password management is handled through your Google Account.
          </div>
        ) : (
          <>
            <input
              style={input}
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />

            <div
              style={{
                fontSize: 12,
                color: "#888",
                marginBottom: 10
              }}
            >
              Must be 8+ characters with uppercase, lowercase,
              number and special character.
            </div>

            <button
              style={button}
              onClick={updatePassword}
              onMouseOver={(e) =>
                (e.target.style.background = "#34495e")
              }
              onMouseOut={(e) =>
                (e.target.style.background = "#2c3e50")
              }
            >
              🔐 Update Password
            </button>
          </>
        )}


        {/* ABOUT */}

        <hr style={{ margin: "25px 0" }} />

        <div

          style={{

            padding: 20,

            border: "1px solid #eee",

            borderRadius: 10,

            background: "#fafafa"

          }}

        >

          <h3 style={{ marginTop: 0 }}>ℹ️ About Mukbi</h3>

          <p><b>Version:</b> 1.0 RC1</p>

          <p><b>Product:</b> Mukbi CRM</p>

          <p><b>Support:</b> +91 97787 97784</p>

          <p style={{ color: "#777", fontSize: 13 }}>

            Built with ❤️ in India

            <br />

            © 2026 Mukbi Holdings

          </p>

        </div>

      </div>

    </div>

  );

}

export default Profile;